


































































































































import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DataSource } from '@/types';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Product } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule
    }
})
export default class ProductsListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this)
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public deleteProduct() {
        this._windowsService!.showDialog(
            localize('ProductSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const product = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    Products_Partial: [
                        {
                            id: product.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<Product>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }
}
